import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../components/shared/Loading";
import PageContainer from "../../components/template/PageContainer";
import { protectedLeaf } from "../../router/route-contracts";

const Screen = lazy(() => import("../../views/my-projects"));

export const Route = createFileRoute("/_protected/my-projects")({
  component: RouteComponent,
  staticData: protectedLeaf({
    requiredRoles: [],
    routeKey: "my-projects",
    access: "protected",
    layout: "modern",
    container: "default",
  }),
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <PageContainer
        pageContainerType={Route.options.staticData?.container}
        footer={Route.options.staticData?.footer}
      >
        <Screen />
      </PageContainer>
    </Suspense>
  );
}
